export default "__VITE_ASSET__586130cd__"